// 다중 셀 "계산(compute) 일괄 적용"의 순수 로직 — 계산 입력 name 자동 생성을 EditorPage/CellComputeEditor에서
// 분리해 단위 테스트 가능하게 한다.
// 결정 기록: docs/decisions/2026-06-29-composer-computed-values-data-side-not-cell-refs.md

/** 계산 입력 name 자동 생성 — a, b, c … (26개 초과 시 input{n}). */
export function nextComputeInputName(index: number): string {
  return index < 26 ? String.fromCharCode(97 + index) : `input${index + 1}`;
}
